<page-title [title]="title"></page-title>
<p>Veja abaixo os especialistas disponíveis para agendar a sua consulta, se preferir, realize sua busca no campo abaixo:</p>
<form class="row">
  <div class="col-xs-12">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Digite sua busca pela especialidade, especialista ou cidade</mat-label>
      <input
        type="text"
        matInput
        [(ngModel)]="search"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Digite aqui os detalhes do agendamento (tipo de serviço; paciente; data)"
      />
    </mat-form-field>
  </div>
</form>
<div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionersFilter">
  <mat-card (click)="openEncounterRegistrationForm(practitioner)">
    <div class="col-xs-5 col-md-3">
      <page-avatar [gender]="practitioner.gender" [avatar]="practitioner.avatar"></page-avatar>
    </div>
    <div class="col-xs-7 col-md-9">
      <div class="content">
        <b
          >{{ getPrefix(practitioner) }} {{ practitioner.name }} <br />
          {{ getSpecialization(practitioner) }}</b
        >
        <br />
        {{ getCity(practitioner) }}
      </div>
    </div>
  </mat-card>
</div>
